import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import TextInput from '@xingternal/malt-text-input';
import { PrimaryButtonMedium as Button } from '@xingternal/malt-button';

import PageviewTracker from '../../../Components/PageviewTracker/PageviewTracker';
import StretchButtonGroup from './../../../Components/StretchButtonGroup/StretchButtonGroup';
import FormMessage from './../../../Components/FormMessage/FormMessage';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import messages from './messages';

const getMaxDate = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  return today.toISOString().split('T')[0];
};

const SearchCriteriaStep = ({
  handleChange,
  genericError,
  values: {
    firstname,
    lastname,
    birthdate,
    city,
    possibleEmail1,
    possibleEmail2,
  },
  errors,
  intl: { formatMessage },
}) => (
  <>
    <PageviewTracker
      pageName={'wbm/Welcome/login/recovery/account/no_credentials'}
    />

    <CustomH>
      <FormattedMessage {...messages.title} />
    </CustomH>

    <CustomP>
      <FormattedMessage {...messages.description1} />
    </CustomP>

    <CustomP>
      <FormattedMessage {...messages.description2} />
    </CustomP>

    <TextInput
      name={'firstname'}
      onChange={handleChange}
      label={<FormattedMessage {...messages.firstnameLabel} />}
      value={firstname}
      message={errors.firstname}
      type={'text'}
      size={'m'}
      required
      autoFocus
    />

    <TextInput
      name={'lastname'}
      onChange={handleChange}
      label={<FormattedMessage {...messages.lastnameLabel} />}
      value={lastname}
      message={errors.lastname}
      type={'text'}
      size={'m'}
      required
    />

    <TextInput
      name={'birthdate'}
      onChange={handleChange}
      label={<FormattedMessage {...messages.birthdateLabel} />}
      value={birthdate}
      message={errors.birthdate}
      type={'date'}
      max={getMaxDate()}
      placeholder={formatMessage(messages.datePlaceholder)}
      size={'m'}
      required
    />

    <TextInput
      name={'city'}
      onChange={handleChange}
      label={<FormattedMessage {...messages.cityLabel} />}
      value={city}
      message={errors.city}
      type={'text'}
      size={'m'}
    />

    <CustomP>
      <FormattedMessage {...messages.emailsExplanation} />
    </CustomP>

    <TextInput
      name={'possibleEmail1'}
      onChange={handleChange}
      label={<FormattedMessage {...messages.email1Label} />}
      value={possibleEmail1}
      message={errors.possibleEmail1}
      type={'email'}
      size={'m'}
    />

    <TextInput
      name={'possibleEmail2'}
      onChange={handleChange}
      label={<FormattedMessage {...messages.email2Label} />}
      value={possibleEmail2}
      message={errors.possibleEmail2}
      type={'email'}
      size={'m'}
    />

    <FormMessage formMessage={{ error: genericError }} />

    <StretchButtonGroup>
      <Button type={'submit'}>
        <FormattedMessage {...messages.buttonContinue} />
      </Button>
    </StretchButtonGroup>
  </>
);

export default injectIntl(SearchCriteriaStep);
